/* eslint require-jsdoc: 'error', valid-jsdoc: ["error", { "requireReturn": false }] */
import MSCartesian from './mscartesian';
import MarimekkoDataset from '../_internal/datasets/marimekko';
import Marimekkogroup from '../_internal/datasets/groups/marimekko.stack';
import msDatasetFactory from '../_internal/factories/multiseries-dataset';
import {pluckNumber} from '../_internal/lib/lib';

/**
 * class for Marimekko chartAPI
 */
class Marimekko extends MSCartesian {
  /**
   * Provides the name of the chart extension
   *
   * @static
   * @return {string} The name of the chart extension
   */
  static getName () {
    return 'Marimekko';
  }

  /**
   * Constructor funtion for Marimekko chartAPI
   */
  constructor () {
    super();
    this.isValueAbs = true;
    this.distributedColumns = true;
    this.stack100percent = true;
    this.isStacked = true;
    this.showsum = 1;
    this.registerFactory('dataset', function (chart) {
      msDatasetFactory(chart);
      let children = chart.getChildren(),
        canvas = children.canvas[0],
        vCanvas = canvas.getChildren('vCanvas')[0],
        dsType = chart.config.defaultDatasetType || '',
        manager = vCanvas.getChildren('datasetGroup_' + dsType)[0];

      manager.addToEnv('categories', chart.getFromEnv('dataSource').categories);
    }, ['vCanvas']);
  }
  /**
   * Sets the name of the component
   * @return {string} name
   */
  getName () {
    return 'Marimekko';
  }

  /**
   * Parse the chart attributes and store in chart's config
   * @param {Object} dataObj User input json
   */
  parseChartAttr (dataObj) {
    super.parseChartAttr(dataObj);
    this.config.showXAxisPercentValues = pluckNumber(dataObj.chart && dataObj.chart.showxaxispercentvalues, 1);
  }

  /**
   * Set default chart configuration
   */
  __setDefaultConfig () {
    super.__setDefaultConfig();
    let config = this.config;
    config.friendlyName = 'Marimekko Chart';
    config.defaultDatasetType = 'marimekko';
    config.isstacked = true;
    config.showpercentvalues = 0;
    config.usepercentdistribution = 1;
    config.showsum = 1;
    config.enablemousetracking = true;
  }

  /**
   * This method return the dataset definations for this charts
   * @return {Object} Column dataset definition
   */
  getDSdef () {
    return MarimekkoDataset;
  }

  /**
   * This method return the dataset-group definations for this charts
   * @return {Object} Multiseries column group definition
   */
  getDSGroupdef () {
    return Marimekkogroup;
  }
}
export default Marimekko;
